module.exports = __webpack_public_path__ + "img/drawer-img-02.f2a479b2.jpg";